import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/auth/Login";
import SignUp from "@/views/auth/SignUp";
import CreatePayment from "@/views/profile/payments/tabs/CreatePayment";
import Payments from "@/views/profile/payments/Payments";
import ArchivePayments from "@/views/profile/payments/tabs/ArchivePayments";
import Cart from "@/views/profile/Cart";
import LoginOtp from "@/views/auth/LoginOtp";
import SignUpOtp from "@/views/auth/SignUpOtp";
import PaymentSuccess from "@/views/profile/PaymentSuccess";
import UserPage from "@/views/profile/user/UserPage.vue";
import store from "@/store";
import middlewarePipeline from "@/router/middleware-pipline";
import guest from "@/router/middleware/guest";
import loggedIn from "@/router/middleware/logged-in";
import PaymentError from "@/views/profile/PaymentError";
import PaymentStatus from "@/views/profile/PaymentStatus";
import PaymentPending from "@/views/profile/PaymentPending";
import LoginPhoneCall from "@/views/auth/LoginPhoneCall";
import LoginOtpCustom from "@/views/auth/LoginOtpCustom.vue";
import UserCards from "@/views/profile/user/tabs/UserCards.vue";
import UserNotaryCard from "@/views/profile/user/tabs/UserNotaryCard.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      layout: "auth-layout",
      middleware: [guest],
    },
  },
  {
    path: "/login/otp",
    name: "LoginOtp",
    component: LoginOtp,
    meta: {
      layout: "auth-layout",
      middleware: [guest],
    },
  },
  {
    path: "/login/otp/custom",
    name: "LoginOtpCustom",
    component: LoginOtpCustom,
    meta: {
      layout: "auth-layout",
      middleware: [guest],
    },
  },
  {
    path: "/login/phone-call",
    name: "LoginPhoneCall",
    component: LoginPhoneCall,
    meta: {
      layout: "auth-layout",
      middleware: [guest],
    },
  },
  {
    path: "/sign-up",
    name: "SignUp",
    component: SignUp,
    meta: {
      layout: "auth-layout",
      middleware: [guest],
    },
  },
  {
    path: "/sign-up/otp",
    name: "SignUpOtp",
    component: SignUpOtp,
    meta: {
      layout: "auth-layout",
    },
  },
  {
    path: "/",
    name: "Payments",
    component: Payments,
    meta: { layout: "app-layout", middleware: [loggedIn] },
    children: [
      {
        path: "",
        component: CreatePayment,
        meta: { layout: "app-layout", middleware: [loggedIn] },
      },
      {
        path: "archive",
        component: ArchivePayments,
        meta: { layout: "app-layout", middleware: [loggedIn] },
      },
    ],
  },
  {
    path: "/me",
    component: UserPage,
    meta: {
      layout: "app-layout",
      middleware: [loggedIn],
    },
    children: [
      {
        path: "",
        component: UserNotaryCard,
        meta: { layout: "app-layout", middleware: [loggedIn] },
      },
      {
        path: "user-cards",
        component: UserCards,
        meta: { layout: "app-layout", middleware: [loggedIn] },
      },
    ],
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
    meta: {
      middleware: [loggedIn],
    },
  },
  {
    path: "/order/:id/success",
    name: "OrderSuccess",
    component: PaymentSuccess,
    props: true,
    meta: {
      middleware: [loggedIn],
    },
  },
  {
    path: "/order/:id/error",
    name: "OrderError",
    component: PaymentError,
    props: true,
    meta: {
      middleware: [loggedIn],
    },
  },
  {
    path: "/order/:id/pending",
    name: "OrderPending",
    component: PaymentPending,
    props: true,
    meta: {
      middleware: [loggedIn],
    },
  },
  {
    path: "/order/:id/payment-status",
    name: "Payment",
    component: PaymentStatus,
    props: true,
    meta: {
      middleware: [loggedIn],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    next,
    store,
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
